import { createContext } from 'react'
import { RadioGroupState } from '@react-stately/radio'

const RadioContext = createContext<RadioGroupState | null>(null)

export { RadioContext }
